import React from 'react';
import { RosterTemplateForm } from './RosterTemplateForm';

export const RosterTemplateScreen = () => {
  return <RosterTemplateForm />;
};
